import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$lang/_layout/$slug")({
  component: () => <Outlet />,
});
